import APIUtils from "./APIUtils";

async function apiRequest({ endpoint = '', method = 'GET', payload = null, stringify = true }, cb) {
    const url = `${APIUtils.getBaseUrl()}${endpoint}`
    
    try {
        APIUtils.getHeaders(async (headers) => {
            try {
                if (!stringify) {
                    headers.append('X-Requested-With', 'XMLHttpRequest');
                }
                
                const response = await fetch(url, {
                    method,
                    headers,
                    ...(payload != null ? { body: stringify ? JSON.stringify(payload) : payload } : {}),
                });

                if (!response.ok) {
                    console.error(`API request failed: ${method} ${url}`, {
                        status: response.status,
                        statusText: response.statusText
                    });
                    
                    // Try to parse error response
                    try {
                        const errorJson = await response.json();
                        cb({ error: true, status: response.status, message: errorJson });
                    } catch {
                        cb({ error: true, status: response.status, message: response.statusText });
                    }
                    return;
                }

                const json = await response.json();
                cb(json);
            } catch (error) {
                console.error(`API request error: ${method} ${url}`, error);
                cb({ error: true, message: error.message });
            }
        });
    } catch (error) {
        console.error(`API request setup error: ${method} ${url}`, error);
        cb({ error: true, message: error.message });
    }
}

export async function awsApiRequest(
    { endpoint = '', method = 'GET', params = null, payload = null, stringify = true, apiName = "", responseType = "json" }, cb) {
    try {
        const url = `${APIUtils.getAWSUrl()}/${APIUtils.GATE_API}/${apiName}${endpoint}` + (params ? APIUtils.getUrlParams(params) : '');
        const headers = await APIUtils.getAWSHeaders();
        const response = await fetch(url, {
            method,
            headers,
            ...(payload != null ? { body: stringify ? JSON.stringify(payload) : payload } : {}),
        });

        if (!response.ok) {
            if (response.status === 404) {
                throw new Error("Resource not found");
            }
            throw new Error("Internal server error");
        } else {
            if (response.status === 204) {
                cb({ success: true });
            } else if (responseType === "csv") {
                const data = response.status === 200 ? await response.blob() : null;
                cb(data);
            } else {
                const responseBody = await response.json();
                cb(responseBody);
            }
        }
    } catch (error) {
        console.error(error.message);
        if (responseType === "json") {
            cb({ success: false, message: error.message });
        } else if (responseType === "csv") {
            cb(null);
        } else {
            throw error;
        }
    }

}



export default apiRequest;